(function () {
  const config = window.__CGC && window.__CGC.bugsnag;
  if (!config || !window.Bugsnag) return;

  // Only the published theme. Skips `shopify theme dev` and unpublished theme previews.
  const themeRole = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
  if (themeRole !== 'main') return;

  // Crawlers, uptime checkers, Lighthouse and automated browsers.
  const BOT_USER_AGENT =
    /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|gtmetrix|pingdom|uptime|prerender|phantomjs|selenium|puppeteer|playwright|facebookexternalhit|bingpreview|google-inspectiontool|ahrefs|semrush|mj12/i;

  const userAgent = navigator.userAgent || '';
  if (!userAgent || navigator.webdriver === true || BOT_USER_AGENT.test(userAgent)) return;

  // e.g. "/cdn/shop/t/123/assets/". Matching on the path only means it works on both
  // the custom domain and *.myshopify.com, and in `shopify theme dev`.
  const themeAssetPath = new URL(config.assetBase, location.href).pathname;

  function isThemeAsset(file) {
    if (!file) return false;
    try {
      return new URL(file, location.href).pathname.startsWith(themeAssetPath);
    } catch (e) {
      return false;
    }
  }

  window.Bugsnag.start({
    apiKey: config.apiKey,
    releaseStage: 'production',
    collectUserIp: false,
    onError(event) {
      // Drop anything that doesn't touch our own scripts: app embeds, GTM tags,
      // browser extensions, inline scripts and cross-origin "Script error." reports.
      let fromTheme = false;
      event.errors.forEach((error) => {
        error.stacktrace.forEach((frame) => {
          frame.inProject = isThemeAsset(frame.file);
          if (frame.inProject) fromTheme = true;
        });
      });
      return fromTheme;
    },
  });
})();
